import React, { memo } from 'react';

import { SharedToastProps } from '../../types/SharedToastProps';
import { Box } from '../Box/Box';
import { StatusMessage } from '../StatusMessage/StatusMessage';

export const Toast = memo((props: SharedToastProps) => {
  return (
    <Box w="toast.width">
      <StatusMessage {...props} />
    </Box>
  );
});
